"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_DATEV_ACCOUNT_NUMBER_LENGTH = exports.MIN_DATEV_ACCOUNT_NUMBER_LENGTH = exports.MAX_DATEV_CONSULTANT_NUMBER = exports.MIN_DATEV_CONSULTANT_NUMBER = exports.MAX_DATEV_CLIENT_NUMBER = exports.MIN_DATEV_CLIENT_NUMBER = exports.ALLOWED_DATEV_BU_CODES = void 0;
exports.ALLOWED_DATEV_BU_CODES = [
    ...[...Array(19).keys()].map((i) => i + 1), // 1-19
    40,
    44,
    46,
    47,
    49,
    ...[...Array(10).keys()].map((i) => i + 50), // 50-59
    91,
    92,
    94,
    95,
    96,
    97,
    98,
    99,
    101,
    102,
    171,
    174,
    184,
    191,
    200,
    221,
    222,
    225,
    226,
    227,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    240,
    241,
    242,
    243,
    250,
    251,
    252,
    253,
    260,
    270,
    280,
    285,
    286,
    290,
    291,
    295,
    296,
    381,
    400,
    401,
    402,
    490,
    506,
    507,
    511,
    512,
    516,
    517,
    521,
    522,
    525,
    526,
    527,
    531,
    532,
    536,
    537,
    541,
    542,
    546,
    547,
    551,
    552,
    556,
    557,
    561,
    562,
    566,
    567,
    701,
    702,
    705,
    706,
    708,
    709,
    750,
    808,
    881,
    ...[...Array(100).keys()].map((i) => i + 900), // 900-999
    5000,
    6501,
    6502,
    6506,
    6507,
    6511,
    6512,
    6516,
    6517,
    6521,
    6522,
    6526,
    6527,
    6531,
    6532,
    6536,
    6537,
    6541,
    6542,
    6546,
    6547,
    6551,
    6552,
    6556,
    6557,
    6561,
    6562,
    6566,
    6567,
    6701,
    6702,
    6705,
    6706,
    6708,
    6709,
    9401,
    9402,
    9501,
    9506,
    9510,
    9511,
    9701,
    9510,
];
exports.MIN_DATEV_CLIENT_NUMBER = 1;
exports.MAX_DATEV_CLIENT_NUMBER = 99999;
exports.MIN_DATEV_CONSULTANT_NUMBER = 1001;
exports.MAX_DATEV_CONSULTANT_NUMBER = 9999999;
exports.MIN_DATEV_ACCOUNT_NUMBER_LENGTH = 4;
exports.MAX_DATEV_ACCOUNT_NUMBER_LENGTH = 8;
